import React, { createContext, useContext } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

const KoffieThemeContext = createContext({ themePref: 'light', themeMode: 'light', setTheme: () => {}, colors: null });
export const useKoffieTheme = () => useContext(KoffieThemeContext);

export const koffieColors = {
  background: '#f2f0eb',
  surface:    '#ffffff',
  text:       '#0c0c0b',
  muted:      '#8a8780',
  border:     '#dcd9d1',
  accent:     '#c75a0a',
  body:       '#5b5953',
};

const styledTheme = {
  mode: 'light',
  colors: koffieColors,
};

export function KoffieThemeProvider({ children }) {
  React.useEffect(() => {
    document.body.style.backgroundColor = koffieColors.background;
    return () => { document.body.style.backgroundColor = ''; };
  }, []);

  return (
    <KoffieThemeContext.Provider value={{ themePref: 'light', themeMode: 'light', setTheme: () => {}, colors: koffieColors }}>
      <StyledThemeProvider theme={styledTheme}>
        {children}
      </StyledThemeProvider>
    </KoffieThemeContext.Provider>
  );
}
